import { render, staticRenderFns } from "./deviceTypeCategory.vue?vue&type=template&id=6fc63750&scoped=true&"
import script from "./deviceTypeCategory.vue?vue&type=script&lang=js&"
export * from "./deviceTypeCategory.vue?vue&type=script&lang=js&"
import style0 from "./deviceTypeCategory.vue?vue&type=style&index=0&id=6fc63750&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fc63750",
  null
  
)

export default component.exports